
//使用mockjs的模板生成随机数据
const data = {
    "code": 200,
    "data": {
        "today_entry": 55,
        "yesterday_usage": 18,
        "total_usage": 9132,
        "today_usage": 18,
        "total_entry": 10123,
        "yesterday_entry": 20
    },
    "message": "success"
}
export default data;

